export default {
  data() {
    return {
      valid: {
        store_id: false,
        city: false,
        address: false,
        postal_code: false,
        floor: false,
        bell_name: false,
        quantity: false,
        first_name: false,
        last_name: false,
        mobile: false,
        email: false,
      },
      success: {
        store_id: false,
        city: false,
        address: false,
        postal_code: false,
        floor: false,
        bell_name: false,
        quantity: false,
        first_name: false,
        last_name: false,
        mobile: false,
        email: false,
      },
      error: {
        store_id: '',
        city: '',
        address: '',
        postal_code: '',
        floor: '',
        bell_name: '',
        quantity: '',
        first_name: '',
        last_name: '',
        mobile: '',
        email: '',
      },
      errorMessages: {
        firstNameRequired: {
          el: 'Το όνομα είναι υποχρεωτικό.',
          en: 'First name is required.',
          it: 'Il nome è obbligatorio.',
        },
        lastNameRequired: {
          el: 'Το επώνυμο είναι υποχρεωτικό.',
          en: 'Last name is required.',
          it: 'Il cognome è obbligatorio.',
        },
        mobileInvalid: {
          el: 'Το κινητό πρέπει να είναι έγκυρος αριθμός.',
          en: 'Mobile must be a valid number.',
          it: 'Il cellulare deve essere un numero valido.',
        },
        emailInvalid: {
          el: 'Το email πρέπει να είναι έγκυρο.',
          en: 'Email must be valid.',
          it: "L'email deve essere valida.",
        },
        cityRequired: {
          el: 'Η πόλη είναι υποχρεωτική.',
          en: 'City is required.',
          it: 'La città è obbligatoria.',
        },
        addressRequired: {
          el: 'Η διεύθυνση είναι υποχρεωτική.',
          en: 'Address is required.',
          it: "L'indirizzo è obbligatorio.",
        },
        postalCodeRequired: {
          el: 'Ο ταχυδρομικός κώδικας είναι υποχρεωτικός.',
          en: 'Postal code is required.',
          it: 'Il codice postale è obbligatorio.',
        },
        postalCodeInvalid: {
          el: 'Ο ταχυδρομικός κώδικας πρέπει να είναι αριθμός.',
          en: 'Postal code must be a number.',
          it: 'Il codice postale deve essere un numero.',
        },
        floorRequired: {
          el: 'Ο όροφος είναι υποχρεωτικός.',
          en: 'Floor is required.',
          it: 'Il piano è obbligatorio.',
        },
        bellNameRequired: {
          el: 'Το όνομα στο κουδούνι είναι υποχρεωτικό.',
          en: 'Bell name is required.',
          it: 'Il nome sul campanello è obbligatorio.',
        },
        quantityInvalid: {
          el: 'Η ποσότητα πρέπει να είναι από 1 έως 20.',
          en: 'Quantity must be between 1 and 20.',
          it: 'La quantità deve essere compresa tra 1 e 20.',
        },
        insufficient_points: {
          el: 'Δεν έχετε αρκετούς πόντους για αυτή την εξαργύρωση.',
          en: 'You do not have enough points for this redemption.',
          it: 'Non hai abbastanza punti per questo riscatto.',
        },
        insufficient_cashback: {
          el: 'Δεν έχετε αρκετό cashback για αυτή την εξαργύρωση.',
          en: 'You do not have enough cashback for this redemption.',
          it: 'Non hai abbastanza cashback per questo riscatto.',
        },
        storeRequired: {
          el: 'Το κατάστημα είναι υποχρεωτικό.',
          en: 'Store is required.',
          it: 'Il negozio è obbligatorio.',
        },
        invalidCoupon: {
          el: 'Μη έγκυρο κουπόνι.',
          en: 'Invalid coupon.',
          it: 'Coupon non valido.',
        },
      },
    };
  },

  computed: {
    formValid() {
      return (
        this.valid.store_id &&
        this.valid.city &&
        this.valid.address &&
        this.valid.postal_code &&
        this.valid.floor &&
        this.valid.bell_name &&
        this.valid.quantity &&
        this.valid.first_name &&
        this.valid.last_name &&
        this.valid.mobile &&
        this.valid.email
      );
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
  },

  methods: {
    validatePoints() {
      const selectedCoupon = this.selectedCoupon;

      if (!selectedCoupon) {
        this.error.quantity = this.errorMessages.invalidCoupon[this.lang];
        this.success.quantity = false;
        return;
      }

      const totalPointsRequired = selectedCoupon.points * this.redeemCouponsData.quantity;

      const mainLoyaltyProgram = this.userPoints.find(
        (point) => point.loyalty_program_id === this.company.loyalty_program_id
      );

      if (!mainLoyaltyProgram || totalPointsRequired > mainLoyaltyProgram.points) {
        this.error.quantity = this.errorMessages[`insufficient_${this.storeMode}`][this.lang];
        this.success.quantity = false;
        return;
      }

      const canRedeem = selectedCoupon.loyalty_program_ids.every((loyaltyProgramId) => {
        const userPoints = this.userPoints.find(
          (point) => point.loyalty_program_id === loyaltyProgramId
        );

        const availablePoints = userPoints ? userPoints.points : 0;
        return availablePoints >= totalPointsRequired;
      });

      if (!canRedeem) {
        this.error.quantity = this.errorMessages[`insufficient_${this.storeMode}`][this.lang];
        this.success.quantity = false;
        return;
      }

      this.error.quantity = '';
      this.success.quantity = true;
    },
    validateFirstName() {
      if (!this.redeemCouponsData.shipping_details.recipient_information.first_name) {
        this.error.first_name = this.errorMessages.firstNameRequired[this.lang];
        this.success.first_name = false;
      } else {
        this.error.first_name = '';
        this.success.first_name = true;
      }
    },
    validateLastName() {
      if (!this.redeemCouponsData.shipping_details.recipient_information.last_name) {
        this.error.last_name = this.errorMessages.lastNameRequired[this.lang];
        this.success.last_name = false;
      } else {
        this.error.last_name = '';
        this.success.last_name = true;
      }
    },
    validateMobile() {
      const mobile = this.redeemCouponsData.shipping_details.recipient_information.mobile;
      const mobileRegex = /^[0-9]{6,13}$/;
      if (!mobile || !mobileRegex.test(mobile)) {
        this.error.mobile = this.errorMessages.mobileInvalid[this.lang];
        this.success.mobile = false;
      } else {
        this.error.mobile = '';
        this.success.mobile = true;
      }
    },
    validateEmail() {
      const email = this.redeemCouponsData.shipping_details.recipient_information.email;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRegex.test(email)) {
        this.error.email = this.errorMessages.emailInvalid[this.lang];
        this.success.email = false;
      } else {
        this.error.email = '';
        this.success.email = true;
      }
    },
    validateCity() {
      if (!this.redeemCouponsData.shipping_details.recipient_address.city) {
        this.error.city = this.errorMessages.cityRequired[this.lang];
        this.success.city = false;
      } else {
        this.error.city = '';
        this.success.city = true;
      }
    },
    validateAddress() {
      if (!this.redeemCouponsData.shipping_details.recipient_address.address) {
        this.error.address = this.errorMessages.addressRequired[this.lang];
        this.success.address = false;
      } else {
        this.error.address = '';
        this.success.address = true;
      }
    },
    validatePostalCode() {
      const postalCode = this.redeemCouponsData.shipping_details.recipient_address.postal_code;

      if (!postalCode) {
        this.error.postal_code = this.errorMessages.postalCodeRequired[this.lang];
        this.success.postal_code = false;
      } else if (!Number.isInteger(Number(postalCode))) {
        this.error.postal_code = this.errorMessages.postalCodeInvalid[this.lang];
        this.success.postal_code = false;
      } else {
        this.error.postal_code = '';
        this.success.postal_code = true;
      }
    },
    validateFloor() {
      if (!this.redeemCouponsData.shipping_details.recipient_address.floor) {
        this.error.floor = this.errorMessages.floorRequired[this.lang];
        this.success.floor = false;
      } else {
        this.error.floor = '';
        this.success.floor = true;
      }
    },
    validateBellName() {
      if (!this.redeemCouponsData.shipping_details.recipient_address.bell_name) {
        this.error.bell_name = this.errorMessages.bellNameRequired[this.lang];
        this.success.bell_name = false;
      } else {
        this.error.bell_name = '';
        this.success.bell_name = true;
      }
    },
    validateQuantity() {
      const quantity = this.redeemCouponsData.quantity;
      if (!quantity || quantity < 1 || quantity > 20) {
        this.error.quantity = this.errorMessages.quantityInvalid[this.lang];
        this.success.quantity = false;
      } else {
        this.error.quantity = '';
        this.success.quantity = true;
        this.validatePoints();
      }
    },

    resetSuccess() {
      Object.keys(this.success).forEach((key) => {
        this.success[key] = false;
      });
    },
    resetError() {
      Object.keys(this.error).forEach((key) => {
        this.error[key] = '';
      });
    },
    resetValid() {
      Object.keys(this.valid).forEach((key) => {
        this.valid[key] = false;
      });
    },
  },

  watch: {
    selectedCoupon: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.resetSuccess();
        this.resetError();
        this.resetValid();
        this.validateQuantity();
        this.valid.quantity = !!this.redeemCouponsData.quantity && !this.error.quantity;

        if (newVal.isProduct) {
          this.valid.store_id = true;
        } else {
          this.valid.city = true;
          this.valid.address = true;
          this.valid.postal_code = true;
          this.valid.floor = true;
          this.valid.bell_name = true;
          this.valid.first_name = true;
          this.valid.last_name = true;
          this.valid.mobile = true;
          this.valid.email = true;
        }
      },
    },

    ['redeemCouponsData.quantity']: {
      immediate: true,
      handler(val) {
        this.valid.quantity = !!this.selectedCoupon && !!val && !this.error.quantity;
      },
    },
    ['redeemCouponsData.store_id']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.store_id = false;
        } else if (!this.selectedCoupon?.isProduct) {
          this.valid.store_id = !!val && !this.error.store_id;
        } else {
          this.valid.store_id = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_address.city']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.city = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateCity();
          this.valid.city = !!val && !this.error.city;
        } else {
          this.valid.city = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_address.address']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.address = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateAddress();
          this.valid.address = !!val && !this.error.address;
        } else {
          this.valid.address = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_address.postal_code']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.postal_code = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validatePostalCode();
          this.valid.postal_code =
            !!val && !this.error.postal_code && Number.isInteger(Number(val));
        } else {
          this.valid.postal_code = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_address.floor']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.floor = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateFloor();
          this.valid.floor = !!val && !this.error.floor;
        } else {
          this.valid.floor = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_address.bell_name']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.bell_name = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateBellName();
          this.valid.bell_name = !!val && !this.error.bell_name;
        } else {
          this.valid.bell_name = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_information.first_name']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.first_name = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateFirstName();
          this.valid.first_name = !!val && !this.error.first_name;
        } else {
          this.valid.first_name = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_information.last_name']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.last_name = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.validateLastName();
          this.valid.last_name = !!val && !this.error.last_name;
        } else {
          this.valid.last_name = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_information.mobile']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.mobile = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.valid.mobile = !!val && !this.error.mobile;
        } else {
          this.valid.mobile = true;
        }
      },
    },
    ['redeemCouponsData.shipping_details.recipient_information.email']: {
      immediate: true,
      handler(val) {
        if (!this.selectedCoupon) {
          this.valid.email = false;
        } else if (this.selectedCoupon?.isProduct) {
          this.valid.email = !!val && !this.error.email;
        } else {
          this.valid.email = true;
        }
      },
    },
  },
};
